import { IhttpConfig, projectStorage, debounce } from '@tencent/fd-utils';
import { API_PREFIX, KEY_APIS, TOKEN_INTERVAL, DEBOUNCE_TIME, REDIRECT_401_TIMES } from '@/constants/global';
import { showToast } from 'vant';
import { router } from '@/router';

const debouncedRefreshStore = debounce(() => {
  projectStorage.set('isCheckToken', true, new Date().getTime() + TOKEN_INTERVAL);
  // 重置401重定向计数器
  projectStorage.set('redirect_401_times', 0);
}, DEBOUNCE_TIME);

// 获取企微端不同应用或者侧边栏不同tab的专属会跳地址
export const getRedirectUrlByAppKey = () => {
  const appKey = 'index';
  const redirectUrlObj = projectStorage.get('redirectUrl');
  if (!redirectUrlObj) {
    return '';
  }
  let res = undefined;
  Object.keys(redirectUrlObj)?.forEach((key) => {
    // 后端给的key都是形如’qw-records‘的格式
    if (key === appKey) {
      res = redirectUrlObj[key];
    }
  });
  return res;
};

export const httpConfig: IhttpConfig = {
  // 基本配置
  options: {
    baseURL: `${API_PREFIX}`,
    withCredentials: true,
    timeout: 10000,
  },
  // 拦截器相关
  Interceptors: {
    request: {
      // 请求拦截器逻辑
      onFulfilled: (config) => {
        return config;
      },
    },
    // 响应拦截器相关回调
    response: {
      fulfilledCallBacks: {
        error: (res, config) => {
          // 与后端约定，如果是 -1 返回，可以直接复用相应的错误提示消息
          Promise.resolve(showToast({ message: res.message, duration: 3000, type: 'fail', closeOnClick: true }));
          if (KEY_APIS.includes(config.url ?? '')) {
            console.log('projectStorage.namespace1', projectStorage.namespace);
            projectStorage.set('isAuth', false);
            projectStorage.set('isCheckToken', false);
          }
        },
        success: () => {
          // 这里不需要单独针对 checkToken 接口做防抖处理，因为 checkToken 通过后，页面下一步就会是跳转登录，因此防抖中的计时器会被清除
          // 而 isCheckToken 的标记，收敛到 config store 中 checkToken 的方法中即可。
          // 续期isCheckToken
          debouncedRefreshStore();
        },
        time_out: (res) => {
          // 标记登录失效
          projectStorage.set('isAuth', false);
          projectStorage.set('isCheckToken', false);
          const redirectUrl = getRedirectUrlByAppKey();
          // 重定向到合作方入口，换取新的token，重走认证流程
          const redirectTimes = projectStorage.get('redirect_401_times') ?? 0;
          if (redirectTimes < REDIRECT_401_TIMES && redirectUrl) {
            // 自动跳转尝试2次，超过2次，不再自动跳转
            projectStorage.set('redirect_401_times', redirectTimes + 1);
            window.location.href = redirectUrl;
            return;
          }
          // 如果两次都失败了，就不再自动跳转了，并且重置计数器
          projectStorage.set('redirect_401_times', 0);
          Promise.resolve(showToast({ message: `${res.message}`, duration: 3000, type: 'fail', closeOnClick: true }));
          Promise.resolve(router.push('/error'));
        },
        no_permission: (res) => {
          projectStorage.set('isAuth', false);
          projectStorage.set('isCheckToken', false);
          Promise.resolve(showToast({ message: `${res.message}`, duration: 3000, type: 'fail', closeOnClick: true }));
          Promise.resolve(router.push('/error'));
        },
        // 兜底逻辑
        others: () => {
          projectStorage.set('isAuth', false);
          projectStorage.set('isCheckToken', false);
          showToast({ message: '网络异常', duration: 3000, type: 'fail', closeOnClick: true });
          Promise.resolve(router.push('/error'));
          return false;
        },
      },
    },
  },
};
